<template>
  <div class="dataList" style="text-align: left; background:#fff;">
    <el-button type="primary">{{title}}</el-button>
    <div class="qrcode">
      <img src="./soama.png" @click="sao" width="80" height="80" alt="">
    </div>
    <el-row :gutter="10" type="flex" class="row-bg" justify="center">
      <el-col :span="24">
        <!-- <div class="searchCase" v-if="$route.params.status != 3">

          <input type="text" placeholder="请输入关键词" v-model="formData.key">
          <span @click="searchBtn">检索</span>
        </div> -->

        <div>
          <div class="aa">
            <mt-datetime-picker
              ref="picker"
              type="date"
              year-format="{value} 年"
              month-format="{value} 月"
              date-format="{value} 日"
              @confirm="handleConfirm"
              v-model="dateval">
            </mt-datetime-picker>
            <mt-datetime-picker
              ref="picker1"
              type="date"
              year-format="{value} 年"
              month-format="{value} 月"
              date-format="{value} 日"
              @confirm="handleConfirms"
              v-model="dateval">
            </mt-datetime-picker>
          </div>
        <el-row style="margin-bottom:0;background:#fff;" :gutter="16">
          <el-col :lg='5' :md='8' :sm='24' :xs='24'>
            <div class="block">
              <div class="title">
                服务委托书编号：
              </div>
              <div>
                <el-input v-model="formData.caseNo" placeholder="请填写编号"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :lg='5' :md='8' :sm='24' :xs='24'>
            <div class="block">
              <div class="title">
                VIN：
              </div>
              <div>
                <el-input v-model="formData.vin" placeholder="请填写vin"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :lg='5' :md='8' :sm='24' :xs='24' v-if="$route.params.status == 'tmci'">
            <div class="block">
              <div class="title">
                经销店代码：
              </div>
              <div>
                <el-input v-model="formData.dealerCode" placeholder="请填写经销店代码"></el-input>
              </div>
            </div>
          </el-col>
          <el-col  :lg='9' :md='24' :sm='24' :xs='24'>
            <div class="block">
              <div class="title">
                上传时间：
              </div>
              <div>
                <el-date-picker placeholder="开始日期" type="date" :clearable="true" value-format="yyyy-MM-dd" v-model="formData.startDate"></el-date-picker>
              </div>
              <div>
                <el-date-picker placeholder="结束日期" type="date" :clearable="true" value-format="yyyy-MM-dd" v-model="formData.endDate"></el-date-picker>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="searchCase1">

          <!-- <input type="text" placeholder="请输入关键词" v-model="formData.key"> -->
          <span @click="searchBtn">检索</span>
        </div>
        <div class="block">
          <div class="title">
            总共：
          </div>
          {{totalElements}}件
        </div>
        </div>
        <!-- <div class="newsCaseList" style="text-align: center" v-if="!newsCaseListData.length">暂无案件</div> -->
          <div class="newsCaseList" v-for="item in newsCaseListData" :key="item.id">
          <ul>
            <li>
              <span>DLR名称：</span>
              <span>{{item.dealerName}}</span>
            </li>
            <li>
              <span>服务委托书编号：</span>
              <span>{{item.caseNo}}</span>
            </li>
            <li>
              <span>VIN&nbsp;编码：</span>
              <span>{{item.vin}}</span>
            </li>
            <li>
              <span>上传人：</span>
              <span>{{item.uploadUserName}}</span>
            </li>
            <li>
              <span>上传时间：</span>
              <span>{{item.uploadDatetime}}</span>
            </li>
            <li v-if="$route.params.status!='2'">
              <span>状态：</span>
              <span>{{item.status}}</span>
            </li>
            <div style="margin-top:10px;">
              <el-button  v-if="user.dlrAdvanceUser" @click="jump(item.id, item.caseNo, item.vin)" style="background:#00ae66;color:#fff;margin-right:10px;" size="small">查看详情</el-button>

              <el-button  v-else-if="!user.dlrAdvanceUser&&($route.params.status==='4'||$route.params.status==='3')" @click="jumps(item.id, item.caseNo, item.vin)" style="background:#00ae66;color:#fff;margin-right:10px;" size="small">查看详情</el-button>
              <el-button  v-else-if="!user.dlrAdvanceUser" @click="jump(item.id, item.caseNo, item.vin)" style="background:#00ae66;color:#fff;margin-right:10px;" size="small">查看详情</el-button>
              <!-- <el-badge :value="item.unreadCount?item.unreadCount:''">
                <el-button size="small" style="background:#00ae66;color:#fff;" @click="chat(item.id)">消息</el-button>
              </el-badge> -->
            </div>
          </ul>
        </div>
        <infinite-loading @infinite="onInfinite" ref="infiniteLoading">
          <span slot="no-more">没有更多消息了</span>
        </infinite-loading>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { getDraftCaseData, getUntreatedCaseData, getHandlingCaseData, getClosingCaseData, searchClosingCaseData, searchHandlingCaseData, searchUntreatedCaseData, searchDraftCaseData } from '@/api/case'
import { getItems } from '@/api/quality'
import { getItems4tmci } from '@/api/quality'
import { Indicator, DatetimePicker, Toast, MessageBox } from 'mint-ui'
import axios from '@/utils/api.request'
import InfiniteLoading from 'vue-infinite-loading'
import {
  getDefaultTableData,
  getOptions,
  getTableData,
  getArealist1,
  getArealist,
  getLeader
} from '@/api/export.js'
export default {
  components: {
    InfiniteLoading
  },
  data () {
    // 由于是组件，data必须是个函数，这是ES6写法，data后面加括号相当于data: function () {}
    return {
      // 记得return不然接收不到数据
      newsCaseListData: [],
      searchKey: '', // 搜索关键词KEY
      warning: [], // 0黄色预警，1红色预警
      list: [],
      loading: true,
      isLoading: false,
      partIdsArr: [],
      phenomenonIdsArr: [],
      warrantyPeriod: [],
      kubunOption: [],
      warrantyPeriodOption: [],
      directionOption: [],
      leaderArr: [],
      areaOption: [],
      noMore: false,
      pageNumber: 0,
      pageSize: 10,
      cases: [],
      formData: {
        pageSize: 10,
        pageNumber: 0,
        startDate: '',
        endDate: '',
        caseNo: '',
        vin: ''
      },
      totalElements: 0,
      user: {},
      dateval: '',
      title: ''
    }
  },
  created () {
    this.user = JSON.parse(localStorage.getItem('user'))
    getOptions(0).then(res => {
      this.directionOption = res.data.directionOption
      this.kubunOption = res.data.kubunOption
      this.partIdsArr = res.data.partOption
      this.phenomenonIdsArr = res.data.phenomenonOption
      this.warrantyPeriodOption = res.data.warrantyPeriodOption
    })
    getLeader().then(res => {
      this.leaderArr = res.data.data
    })
    getArealist().then(res => {
      this.areaOption = res.data.data
    })
    if(this.$route.params.status === '3'){
      this.title = '已提交'
    }else if(this.$route.params.status === '2'){
      this.title = '退回'
    }else if(this.$route.params.status === '1'){
      this.title = '草稿'
    }else if(this.$route.params.status === '0'){
      this.title = '全部数据'
    }else if(this.$route.params.status === '4'){
      this.title = '待审批数据'

    }else if(this.$route.params.status === 'tmci'){
      this.title = '数据管理'

    }
  },
  methods: {
    getNow (d) {
      const year = d.getFullYear()
      const month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
      const date = d.getDate() < 10 ? '0' + (d.getDate()) : d.getDate()
      const hours = d.getHours()
      const minutes = d.getMinutes()
      const second = d.getSeconds()
      let resStr = year + '-' + month + '-' + date
      return resStr
    },
    handleConfirm () {
      console.log(this.getNow(this.dateval))
      this.$set(this.formData, 'startDate', this.getNow(this.dateval))
    },
    handleConfirms () {
      console.log(this.getNow(this.dateval))
      this.$set(this.formData, 'endDate', this.getNow(this.dateval))
    },
    openPicker1 () {
      if (this.formData.endDate) {
        this.dateval = this.formData.endDate
      } else {
        this.dateval = new Date()
      }
      this.$refs.picker1.open()
    },
    openPicker () {
      if (this.formData.startDate) {
        this.dateval = this.formData.startDate
      } else {
        this.dateval = new Date()
      }
      this.$refs.picker.open()
    },
    chat (e) {
      var status = 1
      this.$router.push({ path: '/newsChat/' + status + '/' + e })
    },
    onInfinite ($state) {
      // Indicator.open({
      //   text: '加载中...',
      //   spinnerType: 'fading-circle'
      // });
      if (this.$route.params.status == '1') {
        getItems(this.pageNumber, this.pageSize, {...this.formData, status: '草稿'}).then((res) => {
          this.totalPages = res.data.totalPages
          this.totalElements = res.data.totalElements
          if (res.data.content.length) {
            this.pageNumber += 1
            this.newsCaseListData.push(...res.data.content)
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
          } else {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          }
          if (res.data.content.length < this.pageSize) {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          }
        })
      } else if (this.$route.params.status == '1') {
        getItems(this.pageNumber, this.pageSize, {...this.formData, status: '草稿'}).then((res) => {
          this.totalPages = res.data.totalPages
          this.totalElements = res.data.totalElements
          if (res.data.content.length) {
            this.pageNumber += 1
            this.newsCaseListData.push(...res.data.content)
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
          } else {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          }
          if (res.data.content.length < this.pageSize) {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          }
        })
      } else if (this.$route.params.status == '2') {
        getItems(this.pageNumber, this.pageSize, {...this.formData, status: '退回'}).then((res) => {
          this.totalPages = res.data.totalPages
          this.totalElements = res.data.totalElements
          if (res.data.content.length) {
            this.pageNumber += 1
            this.newsCaseListData.push(...res.data.content)
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
          } else {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          }
          if (res.data.content.length < this.pageSize) {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          }
        })
      } else if (this.$route.params.status == '3') {
        getItems(this.pageNumber, this.pageSize, {...this.formData, status: '通过'}).then((res) => {
          this.totalPages = res.data.totalPages
          this.totalElements = res.data.totalElements
          if (res.data.content.length) {
            this.pageNumber += 1
            this.newsCaseListData.push(...res.data.content)
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
          } else {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          }
          if (res.data.content.length < this.pageSize) {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          }
        })
      } else if (this.$route.params.status == '4') {
        getItems(this.pageNumber, this.pageSize, {...this.formData, status: '待审批'}).then((res) => {
          this.totalPages = res.data.totalPages
          this.totalElements = res.data.totalElements
          if (res.data.content.length) {
            this.pageNumber += 1
            this.newsCaseListData.push(...res.data.content)
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
          } else {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          }
          if (res.data.content.length < this.pageSize) {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          }
        })
      } else if (this.$route.params.status == 'tmci') {
        getItems(this.pageNumber, this.pageSize, {...this.formData, status: '待审批'}).then((res) => {
          this.totalPages = res.data.totalPages
          this.totalElements = res.data.totalElements
          if (res.data.content.length) {
            this.pageNumber += 1
            this.newsCaseListData.push(...res.data.content)
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
          } else {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          }
          if (res.data.content.length < this.pageSize) {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          }
        })
      }
    },
    searchBtn () {
      // Indicator.open({
      //   text: '加载中...',
      //   spinnerType: 'fading-circle'
      // });
      console.log(this.$route.params.status)
      let data = { key: this.searchKey }
      if (this.$route.params.status == 0) {
        // searchDraftCaseData(this.formData).then((res) => {
        //   this.newsCaseListData = res.data.content
        //   Indicator.close();
        // })
        this.formData.pageNumber = 0
        this.pageNumber = 0
        this.pageSize = 20
        this.newsCaseListData = []
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
        this.onInfinite()
      } else if (this.$route.params.status == 1) {
        this.formData.pageNumber = 0
        this.pageNumber = 0
        this.pageSize = 20
        this.newsCaseListData = []
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
        this.onInfinite()
        // searchUntreatedCaseData(this.formData).then((res) => {
        //   this.newsCaseListData = res.data.content
        //   Indicator.close();
        // })
      } else if (this.$route.params.status == 2) {
        searchHandlingCaseData(data).then((res) => {
          this.newsCaseListData = res.data.content
          Indicator.close()
        })
      } else if (this.$route.params.status == '4') {
        // searchClosingCaseData(this.formData).then((res) => {
        //   this.newsCaseListData = res.data.content
        //   Indicator.close();

        // })
        this.formData.pageNumber = 0
        this.pageNumber = 0
        this.pageSize = 20
        this.newsCaseListData = []
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
        this.onInfinite()
      } else if (this.$route.params.status == 'tmci') {
        // searchClosingCaseData(this.formData).then((res) => {
        //   this.newsCaseListData = res.data.content
        //   Indicator.close();

        // })
        this.formData.pageNumber = 0
        this.pageNumber = 0
        this.pageSize = 20
        this.newsCaseListData = []
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
        this.onInfinite()
      } else{
        this.formData.pageNumber = 0
        this.pageNumber = 0
        this.pageSize = 20
        this.newsCaseListData = []
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
        this.onInfinite()
      }
    },
    jump (id, caseNo, vin) {
      console.log(this.$route.params.status)
      if(this.$route.params.status === '4'){
        this.$router.push(`/pendingApproval/${caseNo}/${vin}`)
      }else if(this.$route.params.status === 'tmci'){
        this.$router.push(`/qualityDetails/${caseNo}/${vin}`)
      }else if(this.$route.params.status === '2'){
        this.$router.push(`/qualityUploadData/${id}`)
      }else if(this.$route.params.status === '1'){
        this.$router.push(`/qualityUploadData/${id}`)
      }else{
        this.$router.push(`/qualityDetail/${caseNo}/${vin}`)
        //this.$router.push(`/pendingApproval/${caseNo}/${vin}`)
      }

    },
    jumps (id, caseNo, vin) {
        this.$router.push(`/qualityDetails/${caseNo}/${vin}`)
        //this.$router.push(`/pendingApproval/${caseNo}/${vin}`)

    },
    sao() {
      let _this = this
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"],
        success(res) {
          var result = res.resultStr  // 当needResult 为1时，扫码返回结果
          _this.ticketNum = res.resultStr.split('-')[0]
          _this.vin = res.resultStr.split('-')[1]
          //alert(JSON.stringify(res))
          //_this.$router.push(`/pendingApproval/${_this.ticketNum}/${_this.vin}`)
          if(_this.user.dlrAdvanceUser&&_this.$route.params.status === '4'){
            _this.$router.push(`/pendingApproval/${_this.ticketNum}/${_this.vin}`)
          }else if(_this.$route.params.status === 'tmci'){
            _this.$router.push(`/qualityDetails/${_this.ticketNum}/${_this.vin}`)
          }else if(_this.$route.params.status === '2'){
            _this.$router.push(`/qualityDetailtui/${_this.ticketNum}/${_this.vin}`)
          }else if(_this.$route.params.status === '1'){
            _this.$router.push(`/qualityDetailtui/${_this.ticketNum}/${_this.vin}`)
          }else{
             _this.$router.push(`/qualityDetail/${_this.ticketNum}/${_this.vin}`)
            //_this.$router.push(`/pendingApproval/${_this.ticketNum}/${_this.vin}`)
          }

          //_this.getDetail()
          Toast({
            message: '扫码成功caseNo:'+_this.ticketNum+',vin:'+_this.vin,
            iconClass: 'icon el-icon-check'
          })

        }
      })
    },
    getSign() {
      let _url = location.href.split('#')[0]

      // let _url = ''
      // if (window.__wxjs_is_wkwebview === true) {
      //   _url = window.location.href.split('#')[0] || window.location.href
      // } else {
      //   _url = window.location.href
      // }
      axios.request({
        url: `/api/jsapisign`,
        method: 'post',
        data: {clientUrl: _url,customizeUrl: _url, url: _url}
      }).then(res => {
        // wx.config({
        //   debug: true, // 开启调试模式，调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开
        //   appId: res.data.corpid, // 必填， 公众号的唯一标识
        //   timestamp: res.data.timestamp, // 必填，生成签名的时间戳
        //   nonceStr: res.data.nonceStr, // 必填， 生成签名的随机串
        //   signature: res.data.signature, // 必填，签名
        //   jsApiList: ["scanQRCode"] // 必填，需要使用的JS接口列表
        // })
        wx.config({
          // debug: true, // 开启调试模式，调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开
          // appId: res.data.corpid, // 必填， 公众号的唯一标识
          // timestamp: '1605369404', // 必填，生成签名的时间戳
          // nonceStr: '1b7d09fa-0f29-4b91-876a-f6f3b809701f', // 必填， 生成签名的随机串
          // signature: '8e632b545595bfade3781bbdf42e0750d75361c1', // 必填，签名
          // jsApiList: ["scanQRCode"] // 必填，需要使用的JS接口列表
          beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.corpid, // 必填，企业微信的corpID
          timestamp:  res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature,// 必填，签名，见附录1
          jsApiList: ["chooseImage", "invoke"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
        wx.ready(function () {
          wx.checkJsApi({
            jsApiList: ["invoke", "scanQRCode"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function (ress) {
              // 以键值对的形式返回，可用的api值true，不可用为false
              // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
            }
          });
        })
        // wx.ready(() => {
        //   let _this = this
        //   wx.scanQRCode({
        //     needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        //     scanType: ["qrCode", "barCode"],
        //     success(res) {
        //       var result = res.resultStr  // 当needResult 为1时，扫码返回结果
        //       _this.ticketNum = res.resultStr
        //     }
        //   })
        // })
        wx.error((res) => {
          console.log(res)
        })
      })

    },
    warningClick (e) {
      // 预警选择事件
      console.log(this.cases.length)
      if (e && e.length > 0) {
        if (this.cases.length == 0 || this.cases.join(',').indexOf(e) < 0) {
          this.cases.push(e)
        } else if (this.cases.join(',').indexOf(e) >= 0) {
          this.cases.splice(this.cases.indexOf(e), 1)
        }
        this.formData.casePriority = this.cases.join(',')
      }
      this.formData.pageNumber = 0
      this.pageNumber = 0
      let _this = this
      setTimeout(function () {
        _this.searchBtn()
      }, 0)
    }

  },
  mounted() {
    this.getSign()
  }
}
</script>

<style scoped>
body,
html {
  margin: 0;
  padding: 0;
  background-color: #f4f4f4;
  height:100%;
}
.block {
		line-height: 40px;
		display: flex;
		/* justify-content: space-around; */
	}
.block .title {
		min-width: 115px;
		text-align: right;
	}
ul {
  list-style: none;
  margin: 0px;
  padding: 0px;
}
ul {
  margin: 0;
}
ul li {
  list-style-type: none;
}
.dataList{
  overflow-x: hidden;
	padding: 0.3rem;
  background: #fff;
  height:100%;
}
.searchCase {
  text-align: center;
  height: 40px;
  overflow: hidden;
  background-color: #fff;
  padding: 10px 10px 3px 14px;
  position: relative;
}
.dataList .searchCase1 {
  text-align: center;
  height: 40px;
  overflow: hidden;
  background-color: #fff;
  padding: 10px 10px 3px 14px;
  position: relative;
}
.searchCase input {
  width: calc(100% - 93px);
  height: 34px;
  border: 1px solid #e3e3e3;
  text-indent: 1em;
  border-radius: 3px 0 0 3px;
}
.searchCase span {
  display: block;
  width: 88px;
  float: right;
  font-size: 14px;
  color: #fff;
  height: 36px;
  line-height: 36px;
  background-color: #00ae66;
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  top: 0;
  border-radius: 0 3px 3px 0;
  cursor: pointer;
}
.searchCase1 span {
  display: block;
  width: 88px;
  float: right;
  font-size: 14px;
  color: #fff;
  height: 36px;
  line-height: 36px;
  background-color: #00ae66;
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  top: 10px;
  border-radius: 0 3px 3px 0;
  cursor: pointer;
}
.searchCase span:hover {
  cursor: pointer;
}
.searchCase {
  text-align: left;
  height: 40px;
  overflow: hidden;
  background-color: #fff;
  padding: 10px 15px 3px 15px;
}
.searchCase input {
  width: calc(100% - 120px);
  height: 32px;
  border: 1px solid #e3e3e3;
  text-indent: 1em;
}
.searchCase span {
  display: block;
  width: 88px;
  float: right;
  font-size: 14px;
  color: #fff;
  height: 36px;
  line-height: 36px;
  background-color: #00ae66;
  text-align: center;
  position: relative;
  left: -1px;
}
.searchCase span:hover {
  cursor: pointer;
}
.newsCaseList {
  background-color: #fff;
  text-align: left;
  margin-top: 10px;
  padding: 10px 15px;
}
.newsCaseList ul li {
  overflow: hidden;
  margin-top: 5px;
}
.newsCaseList ul li:hover {
  cursor: pointer;
}
.clOrange {
  color: #ff8f00 !important;
}
.newsCaseList ul li span {
  display: block;
  float: left;
  font-size: 14px;
  color: #333;
}
.infinite-status-prompt {
  margin-top: 10px;
  margin-bottom: 15px;
  height: 60px;
  color: #999;
  font-size: 12px;
}
</style>
